"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeroHeader = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * HeroHeader component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns HeroHeader
 */
/**
 * Primary UI component for user interaction
 */
const HeroHeader = props => {
  const {
    image,
    externalMedia
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-HeroHeader');
  if (!image && !externalMedia) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalMedia && (0, _renderObject.renderObject)(externalMedia), !externalMedia && /*#__PURE__*/_react.default.createElement(_Image.default, {
    desktopImage: image?.desktopImage,
    tabletImage: image?.tabletImage,
    mobileImage: image?.mobileImage,
    altText: image?.altText,
    ratio: image?.ratio,
    loading: image?.loading
  }));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} image - url, altText, ratio and loading prop for Image component
 * @property {object} externalMedia - url, altText, ratio and loading prop for external image or video
 */
exports.HeroHeader = HeroHeader;
HeroHeader.propTypes = {
  /**
   * Allows header prop to accept an object of external media
   */
  externalMedia: _propTypes.default.object,
  /**
   * Allows header prop to accept an object
   * **url** - string
   * **altText** - string
   * **ratio** - oneOf( ['1x1', '4x5', '5x4', '9x16', '16x9'] ),
   * **loading** - string
   */
  image: _propTypes.default.object
};
var _default = exports.default = HeroHeader;